import React, {useState, useEffect, useCallback} from 'react';
import {defineBlock, EditableDiv, smartProps, useEditor, useInspectorControl, useSmartProp} from "@smartfire/gutenberg-react";
import { PanelBody, PanelRow, TextControl } from '@wordpress/components';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import { makeStyles } from '@material-ui/core/styles';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import style from "./block.module.scss";

const useStyles = makeStyles({
  actions: {
    marginTop: 15,
  },
});

const Inspector = ()=>{

    const [cancelText, setCancelText] = useSmartProp("cancelText");
    const [confirmText, setConfirmText] = useSmartProp("confirmText");

     return <>
            <PanelBody title="Action configuration" initialOpen={true}>
                <PanelRow>
                    <TextControl
                        label={"Confirm text"}
                        value={confirmText}
                        onChange={(value) => setConfirmText(value)}
                    />
                </PanelRow>
                <PanelRow>
                    <TextControl
                        label={"Cancel text"}
                        value={cancelText}
                        onChange={(value) => setCancelText(value)}
                    />
                </PanelRow>
            </PanelBody>
        </>;
}

function Block({cancelText, confirmText}) {
  useInspectorControl(Inspector);
  const {isEditing} = useEditor();
  const [open, setOpen] = useState(false);
  const [link, setLink] = useState();
  const [blank, setBlank] = useState();
  const classes = useStyles();

  const openPopup = useCallback((e) => {
      setLink(e.detail.url);
      setOpen(true);
      setBlank(e.detail.blank);
  }, [setLink, setOpen, setBlank]);

  useEffect(() => {
    window.addEventListener('openConfirmPopup', openPopup);
    return () => {
        window.removeEventListener('openConfirmPopup', openPopup);
    };
  }, [openPopup])


  const handleClose = () => {
    setOpen(false);
    setLink(null);
    setBlank(null);
  };

  const handleContinue = () => {
      if(blank){
        var win = window.open(link, '_blank');
        win.focus();
      }
      else{
          window.location.href = link;
      }
    setOpen(false);
  }
 
  return (
    <div className={style.block}>
    {isEditing && <>
        <EditableDiv tagName="h3" smartProp="title"/>
        <h4>Content of the popup</h4>
        <EditableDiv allowedFormats={["core/bold", "core/italic", "core/underline", "advanced/color"]} smartProp="text"/>
        <br/><Button variant="outlined" color="primary" onClick={() => setOpen(true)}>
            Preview the popup
        </Button>
    </>}

      <Dialog
        open={open}
        onClose={handleClose}
      >
        <DialogTitle id="alert-dialog-title"><EditableDiv className={style.title} smartProp="title"/></DialogTitle>
        <DialogContent>
           <EditableDiv smartProp="text" className={style.content}/>
        </DialogContent>
        <DialogActions classes={{root: classes.actions}}>
          <button onClick={handleClose} className={style.btnWhite}>{cancelText}</button>
          <button onClick={isEditing ? handleClose : handleContinue} className={style.btnBlue} autofocus>{confirmText}</button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default defineBlock({
    Block, 
    smartProps: {
        title: smartProps.string.withDefault("Alert"),
        text: smartProps.string.withDefault("You are going to leave this website to open an external link, do you confirm?"),
        confirmText: smartProps.string.withDefault("Confirm"),
        cancelText: smartProps.string.withDefault("Cancel")
    },
    setup: {
        title: "Modal exit confirmation",
        category: "two-third"
    }
});
